export default "__VITE_ASSET__s4jjtQBI__"